/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

export const dateFormats = { DATE_AND_TIME_DEFAULT: "MM/DD/YYYY hh:mm:ss a", DATE_SHORT: "MM/DD/YYYY" };
